export default {
    mounted() {
        const popup = document.querySelector('.v--modal-overlay');
        const { bottom } = this.$refs.fixBottom.getBoundingClientRect();
        if (Math.floor(bottom) > window.innerHeight) {
            popup.classList.add('safari-offset');
        } else {
            popup.classList.add('no-offset');
        }
    },
}